export const SHWE_VAULT_STATUS = 'SHWE_VAULT_STATUS'
export const SHWE_VAULT_OPEN = 'SHWE_VAULT_OPEN'
export const SHWE_VAULT_HISTORY = 'SHWE_VAULT_HISTORY'
